export class BaseApi {
  constructor(axios) {
    this.axios = axios;
  }
}
